/**
 * ATTRIBUTION IS A LICENCE CONDITION, NOT A COURTESY.
 *
 * Every monastery photograph on this site is a real photograph of that
 * monastery, taken from Wikimedia Commons under a Creative Commons licence.
 * CC BY and CC BY-SA both require the author and licence to be shown wherever
 * the work is displayed, with a link back to the source.
 *
 * Deleting this component, or dropping it from a surface that shows a photo at
 * size, breaks the licence on 26 photographs. If a photo has no credit fields
 * it is not cleared for use and renders nothing at all.
 */
export default function PhotoCredit({ photo, variant = 'plain' }) {
  if (!photo?.credit) return null;

  const className = `credit${variant === 'on-photo' ? ' credit--on-photo' : ''}`;

  return (
    <p className={className}>
      <span>
        Photo: {photo.credit}
        {photo.license ? ` · ${photo.license}` : ''}
      </span>
      {photo.sourceUrl && (
        <a href={photo.sourceUrl} target="_blank" rel="noreferrer noopener">
          source
        </a>
      )}
    </p>
  );
}
